import React, { Component } from 'react';

export default class CancelPage extends Component {

    render() {

        return (
            <div className="card">
                <div className="card-heading">
                    <h1 className="card-title">
                        Remove Account / Downgrade
                    </h1>
                </div>
                <div className="card-body">
                    If you would like to remove your account or downgrade from the premium tier to the free tier, please send us an e-mail at <a href="mailto:support@t-rex.online">support@t-rex.online</a>.
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/CancelPage.js